import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// Rxjs dependencies.
import { Subject, BehaviorSubject, Observable } from 'rxjs';

import { AuthService } from '../../core/upgraded-providers';

import { AlertService } from '../../ui.module/alert.service';
import { ConfirmService } from '../../ui.module/confirm.service';
import { ToastrService } from '../../toastr.module/toastr.service';
import { ToastSuccessComponent } from '../../toastr.module/toast-success.component';

import { ArenaService } from '../arena.service';
import { ShowDlgNotEnoughAccessKeysService } from '../show-dlg-not-enough-access-keys.service';

import { StoreService, IResourcesPrice } from '../../shared-services.module/store.service';
import {
  ShowDlgStoreAccessKeyService, TRANSFER_KEYS
} from '../../shared-dialogs.module/show-dlg-store-access-key.service';

const PROMO_GIF_SRC = require('./assets/promo.gif');

@Component({
    templateUrl: './arena.component.pug',
    styleUrls: ['./arena.component.less']
})
export class ArenaComponent implements OnInit, OnDestroy {
  private readonly _destroySbj = new Subject<void>();

  protected readonly PROMO_GIF_SRC = PROMO_GIF_SRC;

  protected accessData: any = {};

  private _user: IUser = {};
  protected set user(user: IUser) {
    this._user = {
      ...user,
      resources: {
        pixel: 0,
        cpuUnlock: 0,
        accessKey: 0,
        ...user.resources
      }
    };
  }
  protected get user() {
    return this._user;
  }

  private _resourcesPriceSbj = new BehaviorSubject<IResourcesPrice>(null);
  private _resourcesPriceLoadingSbj = new BehaviorSubject<string>(null);
  protected resoucesPriceLoading$: Observable<string> = this._resourcesPriceLoadingSbj.asObservable();

  constructor(
    private _route: ActivatedRoute,
    private _alert: AlertService,
    private _confirm: ConfirmService,
    private _toastrSrv: ToastrService,

    private _authSrv: AuthService,
    private _storeSrv: StoreService,
    private _arenaSrv: ArenaService,

    private _dlgStoreAccessKeySrv: ShowDlgStoreAccessKeyService,
    private _dlgDlgNotEnoughAccessKeysSrv: ShowDlgNotEnoughAccessKeysService
  ) {
    // Noop.
  }

  public ngOnInit(): void {
    this.accessData = this._route.snapshot.data['accessData'];
  }

  public ngOnDestroy(): void {
    this._destroySbj.next();
    this._destroySbj.complete();
  }

    async getAccess(type: string, cost: number) {
      this.user = this._authSrv.Me;

      try {
        if (this.user.resources.accessKey < cost) {
          await this._dlgDlgNotEnoughAccessKeysSrv.show();

          await this.showDlgStoreAccessKey();

          this.getAccess(type, cost);
          return;
        }
      } catch (err) {
        return;
      }

      try {
        await this._confirm.show({
          data: {
            title: 'Screeps Arena',
            innerHTML: `<div class='--ui'>You are going to spend <span class='--color-text-keys'>
                  <span class='resource-access-key--dialog'></span>
                  ${ cost } Access Keys</span>.<br />
              Do you want to continue?</div>`,
            buttonOkLabel: 'Yes'
          }
        });
      } catch (err) {
        return;
      }

      try {
        const { steamKey } = await this._arenaSrv.getPurchase();

        this.accessData.steamKey = steamKey;
      } catch (err) {
        console.error(err);
        let message;
        if (typeof err === 'string') {
          message = err;
        } else {
          message = (err && err.data && err.data.error) || 'Error';
        }

        await this._alert.show({ data: {
          message
        }});
      }
    }

  protected async showDlgStoreAccessKey() {
    const loading = this._resourcesPriceLoadingSbj.getValue();
    if (loading) {
      return;
    }

    const resourceType = 'accessKey';

    let resources = this._resourcesPriceSbj.getValue();
    if (!resources) {
      this._resourcesPriceLoadingSbj.next(resourceType);
      resources = await this._storeSrv.resources();
      this._resourcesPriceLoadingSbj.next(null);
      this._resourcesPriceSbj.next(resources);
    }

    let action;
    try {
      action = await this._dlgStoreAccessKeySrv.show({
        // steam: this.user.steam,
        steam: null,
        amount: this.user.resources.accessKey,
        unlimitedAccessKeys: this.user.isUnlimittedAccessKeysSubscriber(),
      });
    } catch (err) {
      console.error('inventory/base::pixelsDlg', err);
      this._authSrv.check();

      throw err;
    }

    if (action.type === TRANSFER_KEYS) {
      this.user.resources[resourceType] -= action.payload;
    }
  }
}
